"use client";

import * as React from "react";
import { Shirt, Activity, Flag, Zap, ShoppingBag } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const industries = [{
  name: "Software Systems",
  icon: Shirt
}, {
  name: "Digital Infrastructure",
  icon: Activity
}, {
  name: "Fintech Solutions",
  icon: Flag
}, {
  name: "Intellectual Property",
  icon: Zap
}, {
  name: "Smart Contracting",
  icon: ShoppingBag
}];
const brands = [{
  name: "Cannabis Cloud",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_amazon_white.png"
}, {
  name: "MilleMaster",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_target_white.png"
}, {
  name: "Crypto Pay Wallet",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_walmart_white.png"
}, {
  name: "Quotient Technology",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_macys_white.png"
}, {
  name: "Nexus Core",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_bloomingdales_white.png"
}, {
  name: "Sovereign Data",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_nordstrom_white.png"
}, {
  name: "Velocity IP",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_tjmaxx_white.png"
}, {
  name: "Ether Bridge",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_dicks_white.png"
}, {
  name: "Protocol 47",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_pga_white.png"
}];
export default function IndustriesBrands() {
  const [api, setApi] = React.useState<CarouselApi>();
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [api]);
  return <section data-section-id="79761" id="active-portfolio" className="bg-background py-24 sm:py-32 overflow-hidden dark">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col">
            <div className="mb-10">
              <h2 className="text-3xl font-default tracking-tighter text-foreground sm:text-5xl mb-4 uppercase">
                Strategic Verticals
              </h2>
              <p className="text-lg font-default text-muted-foreground max-w-md leading-relaxed">
                Eagle 47 provides the unified infrastructure and strategic oversight required to scale modern software ventures and digital assets.
              </p>
            </div>

            <div className="flex flex-col border-t border-border/20">
              {industries.map((industry, i) => {
              const Icon = industry.icon;
              return <div key={industry.name} data-index={i} className="flex items-center gap-6 py-6 border-b border-border/20 group cursor-default transition-all duration-300 hover:bg-card/50 px-4 -mx-4 rounded-sm">
                    <div className="flex items-center justify-center size-12 rounded-sm bg-secondary/30 text-muted-foreground group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300 shadow-sm border border-border/10">
                      <Icon className="size-5" strokeWidth={1.5} />
                    </div>
                    <span className="text-xl font-default font-semibold text-foreground tracking-tight uppercase">
                      {industry.name}
                    </span>
                  </div>;
            })}
            </div>
          </div>

          {}
          <div className="relative bg-card rounded-sm p-8 sm:p-12 lg:p-16 shadow-2xl overflow-hidden isolate border border-border/40">
            {}
            <div className="absolute -top-24 -right-24 size-96 bg-primary/10 rounded-full blur-3xl pointer-events-none mix-blend-soft-light" />
            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
            <div className="absolute top-0 left-8 w-px h-full bg-gradient-to-b from-transparent via-primary/20 to-transparent" />

            <div className="relative z-10">
              <h3 className="text-2xl font-default font-bold text-primary mb-2 uppercase tracking-tight">
                Operating Umbrella
              </h3>
              <p className="text-muted-foreground mb-12 text-sm max-w-sm font-default">
                Presenting the core entities within our high-performance technology and digital commerce portfolio.
              </p>

              <Carousel setApi={setApi} opts={{
              align: "start",
              loop: true
            }} className="w-full">
                <CarouselContent className="-ml-4 sm:-ml-6">
                  {brands.map((brand, i) => <CarouselItem key={brand.name} data-index={i} className="pl-4 sm:pl-6 basis-1/2 sm:basis-1/3">
                      <div className="flex flex-col items-center justify-center h-32 p-6 rounded-sm bg-background/40 border border-border/10 backdrop-blur-md transition-all hover:bg-background/60 hover:border-primary/40 group">
                        <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-10 w-auto object-contain opacity-40 group-hover:opacity-100 transition-opacity duration-500 grayscale group-hover:grayscale-0 brightness-200" />
                        <span className="mt-2 text-[10px] font-mono text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity uppercase tracking-widest">
                          {brand.name}
                        </span>
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                
                <div className="flex items-center justify-end gap-3 mt-10">
                  <CarouselPrevious className="static translate-y-0 translate-x-0 bg-transparent border-border/40 text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary size-10 rounded-sm transition-all duration-300" />
                  <CarouselNext className="static translate-y-0 translate-x-0 bg-transparent border-border/40 text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary size-10 rounded-sm transition-all duration-300" />
                </div>
              </Carousel>
            </div>
          </div>

        </div>
      </div>
    </section>;
}